export const SPARE_DOMAIN_LIST = "SPARE_DOMAIN_LIST";